<template>
    <div class="max pcenter color-light bg-pos-2 bg-size-cover auto-scroll" :style="`backgroundImage: url(${bg.bgImg})`">

        <!--header-->
        <sec-header-widget v-bind="header_data" />

        <!--数据包解决的问题-->
        <section id="sec1" class="pad-h-2 mrg-v-2">
            <div class="rel container pad-h-1 pad-v-4 ">
                <!--遮罩-->
                <matteWidget v-bind="bg" />

                <h3 class="rel mrg-b-3 mrg-b-1-s">
                    <span class="fsize-1d5 fsize-1d1-s">数据包解决的问题</span>
                </h3>
                <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s pad-h-1-s" md>
                    <ul class="grid">
                        <li class="col-8 pad-r-7 pad-t-4 pad-r-0-s col-12-s pad-t-0-s">
                            <list-widget :text-list="introduce" />
                        </li>
                        <li class="col-4 col-12-s">
                            <img class="round-md" :src="require('@/assets/img/daas_case/f6.png')" />
                        </li>
                    </ul>
                </article>
            </div>
        </section>

        <!--数据亮点-->
        <section id="sec2" class="container rel pad-v-4 pad-h-2 mrg-v-2 mrg-v-0-s pad-h-1-s">

            <!--遮罩-->
            <matteWidget v-bind="bg" />

            <h2 class="rel mrg-b-3 mrg-b-1-s"><span class="fsize-1d5 fsize-1-s">数据亮点</span></h2>
            <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s" md>
                <table-widget v-bind="data_character" />
            </article>
        </section>

        <!--数据内容-->
        <section id="sec3" class="container rel pad-v-4 pad-h-1 mrg-v-2 mrg-v-0-s">
            <h3 class="rel mrg-b-3 mrg-b-1-s">
                <span class="fsize-1d5 fsize-1-s">数据内容</span>
            </h3>
            <div class="rel container fsize-1d2 pad-t-2 pleft" md>
                <tab-widget v-model="data_cont.val" :tags-data="data_cont.tagsData">
                    <article v-for="(tag,i) of data_cont.tagsData.tagList" :key="i" :slot="tag.id"
                             class="bg-color-dgray pad-2 round-sm rel">
                        <div class="alpha-d6 mrg-b-2 fsize-d9">{{tag.desc}}</div>
                        <div v-if="tag.text_list">
                            <ul class="grid pcenter">
                                <li class="col-3 col-4-s" v-for="(item,i) of tag.text_list" :key="i">
                                    <b class="color-yellow mrg-r-1">·</b>{{item}}
                                </li>
                            </ul>
                            <img class="round-md" :src="require('@/assets/img/daas_case/f5.png')" />
                        </div>
                        <slider-widget v-if="tag.slider_data" v-bind="tag.slider_data">
                            <img v-for="page of tag.slider_data.pages" :key="page.id" :slot="page.id"
                                 :src="page.src" />
                        </slider-widget>
                    </article>
                </tab-widget>
            </div>
        </section>

        <!--数据应用领域-->
        <section id="sec4">
            <sec-data-apply-widget :bg-color="bg.bgColor" />
        </section>

        <!--获取数据包-->
        <section id="sec5">
            <sec-data-package-widget :matte-data="bg" />
        </section>

        <!--footer-->
        <sec-footer-widget v-bind="footer_data" />
    </div>
</template>

<script>
    import TableWidget from "@/components/BTXUI/table/table-widget"
    import TabWidget from "@/components/BTXUI/tab/tab-widget"
    import SliderWidget from "@/components/BTXUI/slider/slider-widget"
    import ListWidget from "@/components/list-widget"
    import matteWidget from "@/components/matte-widget"
    import SecHeaderWidget from "@/components/sec-header-widget"
    import SecDataPackageWidget from "@/components/sec-data-package-widget"
    import SecDataApplyWidget from "@/components/sec-data-apply-widget"
    import SecFooterWidget from "@/components/sec-footer-widget"

    const name = "cty";

    export default {
        name,
        components: {
            TableWidget,
            TabWidget,
            SliderWidget,
            ListWidget,
            matteWidget,
            SecHeaderWidget,
            SecDataPackageWidget,
            SecDataApplyWidget,
            SecFooterWidget
        },
        props: ["matteData"],
        data(){
            const bg = {
                bgImg: require(`@/assets/img/daas_case/${name}_bg.jpg`),
                bgColor: "dyellow"
            }

            return {

                //背景
                bg,

                //头部信息
                header_data: {
                    packageId: name,
                    mainNavData: {
                        logo: require('@/assets/img/logo/logo.png'),
                        navs: [
                            {
                                text: "首页",
                                link: "/"
                            },
                            {
                                text: "数据包解决的问题",
                                link: {
                                    chapter_id: "sec1",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据亮点",
                                link: {
                                    chapter_id: "sec2",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据包内容",
                                link: {
                                    chapter_id: "sec3",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据应用领域",
                                link: {
                                    chapter_id: "sec4",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "获取数据包",
                                link: {
                                    chapter_id: "sec5",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            }
                        ]
                    }
                },

                //数据包解决的问题
                introduce: [
                    "国家住建部发布《关于支持开展2020城市体检工作的函》中明确指出，需要各城市结合第三方城市体检结果。",
                    "开展城市体检工作的目的是，查找城市发展和城市规划建设管理存在的真正问题，补齐城市建设短板和不足，不断提高城市人居环境质量。建立城市体检评估机制，有利于推进城市治理体系和治理能力现代化。"
                ],

                //数据亮点
                data_character: {
                    thead: [
                        {
                            title: "<b class='color-yellow mrg-r-1'>·</b>清华城市研究院官方数据模型",
                            grow: 1
                        },
                        {
                            title: "<div class='alpha-d6 fsize-d9'>本数据包依据清华大学城市研究院为国家住建部开发的官方指标体系开发而成。基础数据来自清华DaaS实时数据库。</div>",
                            grow: 2
                        }
                    ],
                    tbody: [
                        ["<b class='color-yellow mrg-r-1'>·</b>2019 年、2020 年住建部指标体系", "<div class='alpha-d6 fsize-d9'>2019、2020年，国家住建部已连续两年使用本数据包提供的第三方基础数据为全国36个城市进行体检和分析。</div>"],
                        ["<b class='color-yellow mrg-r-1'>·</b>实时测算每月更新", "<div class='alpha-d6 fsize-d9'>与官方以年为时间单位相比本数据包基于实时基础数据构建而成，每月更新。</div>"]
                    ],
                    colors: {
                        thead: "neutral",
                        row: {
                            head: "none",
                            odd: "rgba(134,134,134,.4)",
                            even: "neutral"
                        },
                        line: "none",
                        outline: "none"
                    }
                },

                //数据内容
                data_cont: {
                    val: "index",
                    tagsData: {
                        tagList: [
                            {
                                id: "index",
                                text: "7 大类，115 项指标",
                                desc: "地理范围：目标城市及下属所有区县 起止时间：2019年至今 更新频率：按月更新",
                                text_list: [
                                    "城市活力",
                                    "多元包容",
                                    "绿色生态",
                                    "城市特色",
                                    "生活舒适",
                                    "安全韧性",
                                    "交通便捷",
                                    "城市口碑"
                                ]
                            },
                            {
                                id: "form",
                                text: "数据包形式",
                                desc: "数据包形式包括：“数据表格” 与 “可视化系统”",
                                slider_data: {
                                    pages: [
                                        {
                                            id: "a",
                                            src: require("@/assets/img/daas_case/f3.png")
                                        },
                                        {
                                            id: "b",
                                            src: require("@/assets/img/daas_case/f4.png")
                                        }
                                    ],
                                    view: {
                                        height: "auto"
                                    },
                                    showDot: {
                                        bottom: "15px",
                                        color: "#fff",
                                        act_color: "#ffcc00"
                                    },
                                    showFlipBtn: true,
                                    autoPlayDuration: 4000,
                                    loop: true
                                }
                            }
                        ],
                        colors: {
                            normal: {
                                text: "rgba(255,255,255,.4)",
                                bg: "rgba(0,0,0,.5)",
                            },
                            act: {
                                text: "#ffcc00",
                                bg: "dgray",
                            },
                            hover: {
                                text: "mgray",
                                bg: "rgba(0,0,0,.5)",
                            },
                        }
                    }
                },

                //底部信息
                footer_data: {
                    package: {
                        title: "城市体检数据包",
                        packageId: name,
                        packageName: "第三方城市体检数据",
                        matteData: bg
                    }
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/router/cty.vue